import endpoints from '../endpoints'
import axios from 'axios'
import _ from 'lodash'

const state = {
  content: {}
}

const getters = {
  getBasket: state => state.content,

  emptyBasket: state => (typeof state.content.basket !== 'undefined' && _.size(state.content.basket) === 0),

  basketSize: state => _.size(state.content.basket),

  productSum: (state, getters, rootState) => {
    let sum = 0

    _.each(state.content.basket, function (item) {
      sum += item.price
    })

    return sum
  },

  basketSum: (state, getters) => {
    let sum = getters.productSum

    if (typeof state.content.shipping !== 'undefined' && state.content.shipping.mbw > sum) {
      sum = state.content.shipping.mbw
    }

    if (state.content.coupon && state.content.coupon.success === true) {
      sum -= state.content.coupon.item_discount
    }

    return sum
  },

  basketSumWoMbw: (state, getters) => {
    let sum = getters.productSum

    if (state.content.coupon && state.content.coupon.success === true) {
      sum -= state.content.coupon.item_discount
    }

    if (sum < 0) {
      sum = 0
    }

    return sum
  },

  shippingCosts: (state, getters) => {
    if (typeof state.content.shipping !== 'undefined') {
      return state.content.shipping.value
    }

    return 0
  },

  mbwDeviation: (state, getters) => {
    if (typeof state.content.shipping === 'undefined') return false

    const deviation = (state.content.shipping.mbw - getters.productSum)
    return (deviation > 0 ? deviation : 0)
  }
}

const actions = {
  updateBasket ({ state, commit }) {
    axios.get(endpoints.retrieveBasket)
      .then(response => {
        commit('setBasket', response.data)
      })
      .catch(e => {
        console.log(['failed updating basket', e])
      })
  },

  /**
   * Remove a product from the basket
   * @param {object} vuexInstance
   * @param {Function} vuexInstance.dispatch dispatch a vuex event
   * @param {object} removeData
   * @param {number|string} removeData.basketId the id of the item to delete
   */
  async removeProduct ({dispatch}, {basketId}) {
    return axios.post(endpoints.removeProduct, {
      'basketId': Number(basketId)
    })
      .then(() => {
        dispatch('updateBasket')
      })
  }
}

const mutations = {
  setBasket (state, basketResponse) {
    state.content = basketResponse
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/basket.js